import React from "react";
import * as aserver from '../../APIClient';
import { Button } from "@material-ui/core";
import AephoriaLogo from "../images/Aephoria-logo-blue-login.png"
const axios = require('axios');

const modeSignup = 'signup';
const modeSuccess = 'success';
const modeDone = 'done';
const modeError = 'error';

function getLocalStorageValue(field, defaultValue) {
  return(localStorage.getItem('signup_'+field)??(defaultValue??''));
}

function setLocalStorageValue(field, value) {
  localStorage.setItem('signup_'+field, value);
}

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: modeSignup,
      name: getLocalStorageValue('name'),
      surname: getLocalStorageValue('surname'),
      email: getLocalStorageValue('email'),
      signupUUID: '',
      assessmentType: 'EIT',
      assessmentLanguage: 'english',
      message: getLocalStorageValue('message'),
      coachName: '...',
      coachValid: null,
      processing: false,
      response: null,
      error: null,
    };
  }

  async componentDidMount() {
    let mode = getLocalStorageValue('mode', modeSignup);
    this.setState({ mode: mode })
    if (mode === modeSignup)
      this.initializeSignupMode();
  }

  btranslate(message, ...params) {
    let result = message;
    let index = 0;
    return result.replace(/\{.*?\}/g, () => {
      const replacement = params[index++];
      return replacement !== undefined ? replacement : "";
    });    
  }  

  restartSignup() {
    this.setState({
      mode: modeSignup,
      email: '',
      name: '',
      surname: ''
    })
    this.initializeSignupMode();
  }

  async initializeSignupMode() {
    const pathname = window.location.pathname;
    const parts = pathname.split('/');
    const signupUUID = parts[parts.length - 1];
    const coachValid = signupUUID.length === 36;
    this.setState({ signupUUID });
    this.setState({ coachValid: coachValid })
    setLocalStorageValue('mode', modeSignup);
    if (!coachValid)
      return;
    let init;
    try {
      init = await axios.get(`${aserver.getServerRoot()}/signup/init/${signupUUID}`);
      console.log(init.data);
    } catch (err) {
      this.setState({ coachValid: false })
      return;
    }
    this.setState({
      coachName: init.data.coachName,
    })
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    })
  };

  signupGuest = async () => {
    const { name, surname, email, assessmentType, signupUUID, assessmentLanguage } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let isEmailValid = emailRegex.test(email);
    let areDetailsFilled = email && name && surname && assessmentType
    if (!areDetailsFilled) {
      alert('Please provide all details.')
      return;
    }
    if (!isEmailValid) {
      alert('Please provide a valid email address.');
      return;
    }
    try {
      this.setState({ processing: true })
      setLocalStorageValue('name', name);
      setLocalStorageValue('surname', surname);
      setLocalStorageValue('email', email);
      let checkout = await axios.post(`${aserver.getServerRoot()}/signup/checkout`, {
        name: name,
        surname: surname,
        email: email,
        assessmentType: assessmentType,
        assessmentLanguage: assessmentLanguage,
        signupUUID: signupUUID,
      })
      if (checkout.status === 200) {
        this.setState({
          mode: modeSuccess,
        });
        setLocalStorageValue('mode', modeDone);
      } else {
        throw('Unexpected error in signup.')
      }
    } catch (err) {
      let message = err.response.data.error.description;
      this.setState({ mode: modeError, message: message })
      setLocalStorageValue('mode', modeError);
      setLocalStorageValue('message', message);
    }
    this.setState({processing: false});
  }

  render() {
    let showBody = <></>

    let moreHelp = <>Should you have any queries or require further assistance, please contact us at <a href="mailto:hello@aephoriagroup.com" target="_blank" rel="noreferrer">hello@aephoriagroup.com</a></>

    if (this.state.mode === modeSuccess) {
      const { name, surname, email } = this.state;
      showBody = <div>
        <p>
        Dear {name} {surname}
        <br></br><br></br>
        An invitation to complete your assessment has been emailed to you at {email}. 
        <br></br><br></br>
        {moreHelp}
        <br></br><br></br>
        Best regards,
        <br></br>
        Aephoria
        </p>
      </div>
    } else 
    if (this.state.mode === modeDone) {
      const { name, surname, email } = this.state;
      showBody = <div>
        <p>
          You have successfully signed up {name} {surname} for an Aephoria assessment.
        </p>
        <p>
          Check your {email} email for an invitiation to complete the assessment.
        </p>
        <p>
          If you would like to restart the sign up process to enrol another person, click <div className="fakelink" onClick={() => this.restartSignup()}>here</div>.
        </p>
        <p>{moreHelp}</p>
      </div>
    } else 
    if (this.state.mode === modeError) {
      const { message } = this.state;
      showBody = <div>
        <p>
          There was an error: {message}.
        </p>
          <Button variant="contained" color="primary" type="submit" onClick={() => this.restartSignup()}>
            Restart
          </Button>
      </div>
    } else
    if (this.state.mode === modeSignup) {
      if (!this.state.coachValid) {
        showBody = <>
            Invalid link. Please use the link exactly as provided to you by your coach, and contact your coach for a new link if it still doesn't work.
        </>
      } else {
        showBody = <>
          <div>
            <div>

              <h5 className="selfRegisterHeading" >{this.btranslate('Your Details')}</h5>
              <div className="input-wrapper-1 addClientDiv" >
                <input type="text" name="name" id="name" onChange={this.handleChange} value={this.state.name} autoFocus />
                <label className="edit">{this.btranslate('Name')}</label>
              </div>
              <div className="input-wrapper-1 addClientDiv">
                <input type="text" name="surname" id="surname" onChange={this.handleChange} value={this.state.surname} />
                <label className="edit">{this.btranslate('Surname')}</label>
              </div>
              <div className="input-wrapper-1 addClientDiv">
                <input type="text" name="email" id="email" onChange={this.handleChange} value={this.state.email} />
                <label className="edit">{this.btranslate('Email')}</label>
              </div>
            </div>
            <div>
              <h5 className="selfRegisterHeading">{this.btranslate('Assessment Details')}</h5>
              <div className="styled-select input-wrapper-1">
                <select id="dropdown" onChange={this.handleChange} style={{ textTransform: "capitalize" }} name="assessmentLanguage" value={this.state.assessmentLanguage} required>
                  {aserver.Languages.sort().map((info, i) => {
                    return (
                      <option key={i} value={info}>{info.charAt(0).toUpperCase() + info.slice(1)}</option>
                    )
                  })}
                </select>
                <label>{this.btranslate('Language')}</label>
              </div>
              <div className="input-wrapper-1 addClientDiv">
                <input type="text" name="assessmentType" id="assessmentType" disabled={true} style={{ color: "grey" }} value="Maturity" />
                <label className="edit">{this.btranslate('Assessment')}</label>
              </div>
            </div>
            <div>
              <p>
                The results of your assessment and associated reports will be made available to {this.state.coachName}.
              </p>
              <p>
                By clicking on "Proceed", you agree to <a href="https://aephoriagroup.com/general-terms/" target="_blank" rel="noreferrer">our general terms.</a>
              </p>
            </div>
            <div className="registrationButton">
              <Button variant="contained" color="primary" type="submit" disabled={this.state.processing} onClick={() => this.signupGuest()}>
                {this.state.processing?
                this.btranslate('Please wait...'):
                this.btranslate('Proceed')}
              </Button>
            </div>
            <div style={{textAlign: "center"}}>
              <p>
                <small>Help: <a href="mailto:devteam@aephoriagroup.com" target="_blank" rel="noreferrer">devteam@aephoriagroup.com</a></small>
              </p>
            </div>
          </div>
        </>
      }
    }

    return (
      <main className="selfRegister" >
        <img className="registerFormLogo top-div" src={AephoriaLogo} alt="Aephoria Lab Logo" />
        <div className="selfregisterForm middle-div">
          <div className="selfRegisterFormContent">
            <h1 style={{ "textAlign": "center", "margin": "1vh" }}>{this.btranslate('Assessment Signup')}</h1>
            {showBody}
          </div>
        </div>
      </main>
    );
  }
}

export default Signup
